import React from "react";
import {
  Show,
  DateField,
  TextField,
  ReferenceField,
  SimpleShowLayout,
  useRecordContext,
} from "react-admin";

import RoleChipField from "./RoleChipField";
import { Account } from "../types";

const Title = () => {
  const record = useRecordContext<Account>();
  return (
    <span>
      Benutzer <strong>{record?.emailAddress}</strong>
    </span>
  );
};

const AccountShow = () => (
  <Show title={<Title />}>
    <SimpleShowLayout>
      <TextField source="emailAddress" />
      <RoleChipField source="role" />
      <ReferenceField
        source="customerId"
        reference="Customer"
        sortable={false}
        link="show"
      >
        <TextField source="name" />
      </ReferenceField>
      <DateField source="lastLogin" showTime />
      <DateField source="createdAt" showTime />
      <DateField source="updatedAt" showTime />
    </SimpleShowLayout>
  </Show>
);

export default AccountShow;
